import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: 'ng-template[appSmartGridCell]',
  standalone: true,
})
export class SmartGridCellDirective {
  @Input('appSmartGridCell') field!: string;
  constructor(public template: TemplateRef<any>) {}
}
